var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},_vm.$listeners),[_c('path',{attrs:{"d":"M3.171 4l-.707.707L6 8.243l3.535-3.536L8.828 4 6 6.828 3.17 4z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }